import $ from 'jquery';
import Flickity from 'flickity';
import Base from '../../../_config/base';

class Slider extends Base {
  constructor(el) {
    super(el);
    this.slideItems = el.querySelector('.slider__items');
    this.initializeSlider();
  }

  initializeSlider() {
    /* eslint-disable no-unused-vars */
    // Default config
    const config = {
      setGallerySize: false,
      lazyLoad: true,
      draggable: false,
      autoPlay: 0,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: false,
      // Slide animation duration
      selectedAttraction: 0.1,
      // Slide animation popback
      friction: 0.8,
      arrowShape: { x0: 10, x1: 99, y1: 100, x2: 100, y2: 99, x3: 11 },
      dragThreshold: 10,
    };
    // Extend default for more slides
    if (this.slideItems.querySelectorAll('.slider__item').length > 1) {
      config.autoPlay = 7000;
      config.draggable = true;
      config.pageDots = true;
      config.prevNextButtons = true;
    }
    const flkty = new Flickity(this.slideItems, config);
    /* eslint-enable no-unused-vars */

    // Replace prev svg
    this.$el
      .find('.flickity-prev-next-button.previous svg')
      .addClass('icon')
      .addClass('icon--arrow-left')
      .removeAttr('viewBox')
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')
      .html('<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--arrow-left"></use>');
    this.$el
      .find('.flickity-prev-next-button.next svg')
      .removeAttr('viewBox')
      .addClass('icon')
      .addClass('icon--arrow-right')
      .attr('xmlns', 'http://www.w3.org/2000/svg')
      .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')
      .html('<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--arrow-right"></use>');
    this.$el
      .find('ol.flickity-page-dots li.dot')
      .html('<svg class="icon icon--arrow-left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <use xlink:href="#icon--arrow-left"></use> </svg>');
    this.$el
      .on('click', 'ol.flickity-page-dots li.dot', function () {
        const index = $(this).index();
        //console.log(index, flkty);
        flkty.select(index);
      });

    // Workaround to fix inaccurate Flickity positioning issue ...
    const evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  }
}

Slider.className = 'Slider';
export default Slider;



// WEBPACK FOOTER //
// ./src/materials/molecules/slider/slider.js